const listeners = [];

export default {
    onShutdown: callback => {
        listeners.push(callback);
    },
    shutdown: () => {
        for (let callback of listeners) {
            callback();
        }
    },
};
